import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import CommodityModal from "./components/CommodityModal";

const CommodityCodeFinder = ({
  buttonClassName,
  disabled,
  onCommodityCodeSearch,
  onSearch,
  onSubmit,
  onFindClick,
  findButtonText
}) => {
  const [isCommodityModalOpen, setIsCommodityModalOpen] = useState(false);
  const handleOpen = useCallback(() => {
    setIsCommodityModalOpen(true);
    onFindClick();
  }, [setIsCommodityModalOpen, onFindClick]);
  const handleClose = useCallback(() => setIsCommodityModalOpen(false), [setIsCommodityModalOpen]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    variant: "dark",
    className: buttonClassName,
    onClick: handleOpen,
    disabled: disabled
  }, findButtonText), isCommodityModalOpen && /*#__PURE__*/React.createElement(CommodityModal, {
    show: isCommodityModalOpen,
    onClose: handleClose,
    onSearch: onSearch,
    onCommodityCodeSearch: onCommodityCodeSearch,
    onSubmit: onSubmit
  }));
};

CommodityCodeFinder.propTypes = {
  buttonClassName: PropTypes.string,
  disabled: PropTypes.bool,
  onCommodityCodeSearch: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  findButtonText: PropTypes.string,
  onFindClick: PropTypes.func
};
CommodityCodeFinder.defaultProps = {
  findButtonText: "Find",
  onFindClick: () => {}
};
export default CommodityCodeFinder;